"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuspenseContext = void 0;
const react_1 = require("react");
exports.SuspenseContext = react_1.createContext({});
exports.SuspenseContext.displayName = 'SuspenseContext';
